import { adminClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  baseURL: typeof window !== "undefined" ? window.location.origin : "http://localhost:3000",
  plugins: [adminClient()],
  // Resolve fetch at call time rather than once at import. Identical in the
  // browser; it is what lets a test stub fetch and have the session follow.
  fetchOptions: { customFetchImpl: (input, init) => globalThis.fetch(input, init) },
});

export const { signIn, signUp, signOut, useSession } = authClient;
